import { useSelector } from "react-redux"
import { getSrc } from "../../utilities/enumerations/constants"

export default function CartProductCard({ item }) {
  const cartState = useSelector((state) => state.cart)
  const cart = cartState.posById[item.slug]

  return (
    <li className="list-group-item list-group-item-cart p-2">
      <div className="d-flex gap-2 justify-content-between align-items-center">
        <img src={getSrc(item.thumbnail_url)} alt={item.title} width={40} height={40} className="border rounded-3" />
        <div className="flex-grow-1">
          <p className="fs-12 text-body-emphasis fw-bold m-0">{item.title}</p>
          <p className="fs-12 text-body-secondary fw-bold m-0">x{cart} = {(cart * item.price).toFixed(2)}</p>
        </div>
      </div>
    </li>
  )
}